import { MapViewStore } from "./MapViewStore";
import TrailwiseEventBus from "./TrailwiseEventBus";

export class MapSlidePanel {

    private _lastSlidePanelAction: string = "";
    private _hiddenPanelAction: string | null = null;
    private _isHidden: boolean = false;

    public constructor(
        private _mapStore: MapViewStore,
        private _showOpenPanelByDefault: boolean,
        private _rememberActivePanel: boolean,
    ) {
        this.addSlidingPanelsHandlers();
    }

    /**
     * Hides the whole slide panel including its tab buttons (used while a GPX
     * edit session owns the map). Remembers which panel was open so restore()
     * can bring it back.
     */
    public hideAll = (): void => {
        if (this._isHidden) {
            return;
        }
        this._isHidden = true;

        const panel = $('#slide-panel');
        this._hiddenPanelAction = panel.hasClass("visible")
            ? $('#slide-panel .content-panel:visible').attr('id')?.replace('slide-panel-', '') ?? null
            : null;

        if (panel.hasClass("visible")) {
            $('#slide-panel .content-panel').hide();
            panel.removeClass('visible').css('margin-left', '-315px');
            $('#slide-content').css("opacity", "0");
        }

        $('#slide-headers-container').addClass('d-none');
    }

    /**
     * Expands the panel with the given tab's content shown. Idempotent — unlike
     * clicking the tab button, calling this for an already-open tab will NOT
     * toggle the panel closed. While the panel is suppressed (hideAll, e.g. a GPX
     * edit session owns the map) the request is deferred to the next restore().
     */
    public open = (action: string): void => {
        if (this._isHidden) {
            this._hiddenPanelAction = action;
            return;
        }
        if ($(`#slide-panel-${action}`).is(':visible')) {
            return;
        }
        $(`#slide-panel-btn-${action}`).trigger('click');
    }

    /** Restores the panel hidden by hideAll(), reopening the tab that was open. */
    public restore = (): void => {
        if (!this._isHidden) {
            return;
        }
        this._isHidden = false;

        $('#slide-headers-container').removeClass('d-none');

        if (this._hiddenPanelAction) {
            $(`#slide-panel-btn-${this._hiddenPanelAction}`).trigger('click');
            this._hiddenPanelAction = null;
        }
    }

    private addSlidingPanelsHandlers = (): void => {
        let self = this;
        let lastSlidePanelAction_forScope = self._lastSlidePanelAction;

        let onCloseSlidePanel = function () {
            let panel = $('#slide-panel');
            $('#slide-panel .content-panel').hide();

            panel.removeClass('visible').animate({
                'margin-left': '-315px'
            });

            setTimeout(function () {
                $('#slide-content').css("opacity", "0");
            }, 350);

            lastSlidePanelAction_forScope = null;
            self._mapStore.onActivePanelChanged("none");
        };

        let onSlidePanelClick = function () {
            let panel = $('#slide-panel');
            let action = $(this).data("action");
            let activeContentPanelId = "#slide-panel-" + action;

            if (self._rememberActivePanel === true) {
                self._mapStore.onActivePanelChanged(action);
            }

            //any action other than 'help'
            if (panel.hasClass("visible") && lastSlidePanelAction_forScope === action) {
                onCloseSlidePanel();
                $(this).blur();

            } else if (!panel.hasClass("visible")) {
                //main panel closed

                //close any tooltips open
                $("[data-bs-toggle='tooltip']").tooltip('hide');

                panel.addClass('visible').animate({
                    'margin-left': '0px'
                });
                $('#slide-content').css("opacity", "1");
            }

            if (panel.hasClass("visible")) {
                //hide all the content panels and show the correct one
                $('#slide-panel .content-panel').hide();
                $(activeContentPanelId).show();

                lastSlidePanelAction_forScope = action;

                //panel content only gains layout once shown — anything that has to
                //measure itself (e.g. the GPX notes clamp) listens for this
                TrailwiseEventBus.slidePanelShown(action);

                //we need to initialise the legend maps when the panel is first shown
                //if (action === "overlays") {
                //    self.addOverlays();
                //}
            }

            return false;
        };

        $('.slide-panel-button').on('click', onSlidePanelClick);

        //handle close button on sliding panel
        $('#slide-panel .fa-times').on('click', () => {
            onCloseSlidePanel();
        });

        //set initial state for panel
        if (self._showOpenPanelByDefault) {
            let activePanel = self._mapStore.getMapInfo().activePanel;
            if (!activePanel && activePanel != "none") {
                //show the panel and default to layers
                $("#slide-panel-btn-overlays").click();
            } else if (activePanel != "none") {
                $(`#slide-panel-btn-${activePanel}`).click();
            }
        }
    }
}